import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-spinner d-flex justify-content-center p-2 m-2 bg-white rounded-2 shadow-sm">
    <div class="d-flex align-items-center">
      <div class="p-2 spinner-border text-primary" role="status"></div>
      <div class="p-2 text-gray-600">Carregando...</div>
    </div>
  </div>
`;

export class WCSpinner extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcSpinner = clone.content.querySelector('.wc-spinner');
    this.replaceWith(wcSpinner);
  }

}